<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="name">
        <span slot="label">
          <a-tooltip>
            {{ $t('成就名称') }}<template slot="title">{{ $t('成就名称') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.name" :maxLength="64" :placeholder="$t('请输入')+$t('成就名称')"/>
      </a-form-model-item>
      <a-form-model-item prop="icon">
         <span slot="label">
          <a-tooltip>
            {{ $t('成就图标') }}<template slot="title">{{ $t('成就图标') }}</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.icon" prefix="user" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="picture">
        <span slot="label">
          <a-tooltip>
            {{ $t('成就图片') }}<template slot="title">{{ $t('成就图片') }}</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.picture" prefix="user" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="pictureDark">
        <span slot="label">
          <a-tooltip>
            {{ $t('成就图片(暗)') }}<template slot="title">{{ $t('成就图片(暗)') }}</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.pictureDark" prefix="user" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="type">
        <span slot="label">
          <a-tooltip>
            {{ $t('成就类型') }}<template
              slot="title">{{ $t('成就类型') }}</template>
          </a-tooltip>
        </span>
        <a-select
          :placeholder="$t('请选择')+$t('成就类型')"
          style="width: 100%"
          v-model="form.type"
          allowClear>
          <a-select-option
            v-for="(item, index) in this.customDict.ChallengeTypeEnum"
            :value="item.type"
            :key="index">
            {{item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="achieveCondition">
        <span slot="label">
          <a-tooltip>
            {{ $t('成就条件') }}<template slot="title">{{ $t('成就条件') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.achieveCondition" oninput="value=value.replace(/[^\d]/g,'')" :placeholder="$t('请输入')+$t('成就条件')">
          <a-tooltip v-if="form.type===1" slot="suffix" title="达成此成就需要解锁的角色个数">
            个
          </a-tooltip>
          <a-tooltip v-if="form.type===2" slot="suffix" title="达成此成就需要对话的分钟数">
            分钟
          </a-tooltip>
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label">
          <a-tooltip>
            {{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getChallengeConfig, addChallengeConfig, updateChallengeConfig } from '@/api/user/challengeConfig'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import OssUploadSingle from '@/components/OssUploadSingle/index.vue'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    OssUploadSingle,
    CustomDictTag
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        icon: null,

        picture: null,
        pictureDark: null,
        type: null,

        achieveCondition: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: this.$t('成就名称') + this.$t('不能为空'), trigger: 'blur' }
        ],
        icon: [
          { required: true, message: this.$t('成就图标') + this.$t('不能为空'), trigger: 'blur' }
        ],
        picture: [
          { required: true, message: this.$t('成就图片') + this.$t('不能为空'), trigger: 'blur' }
        ],
        type: [
          {
            required: true,
            message: this.$t('成就类型 1 角色 2 对话') + this.$t('不能为空'),
            trigger: 'change'
          }
        ],
        achieveCondition: [
          { required: true, message: this.$t('成就条件') + this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        icon: null,
        picture: null,
        pictureDark: null,
        type: null,
        achieveCondition: null,
        createTime: null,
        remark: null
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getChallengeConfig({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateChallengeConfig(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addChallengeConfig(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
